import React, { useEffect, useState } from "react"
import { copyText } from "frontend/utils/copy"
import t from "frontend/utils/translations"
import styles from "./MobileShare.module.css"

const MobileShareItem = ({ copyableText, icon, label, onClick }) => {
  const [showCopySuccess, setShowCopySuccess] = useState(false)
  let timeout = null
  const handleClick = () => {
    if (copyableText) {
      copyText(copyableText)
      setShowCopySuccess(true)
      timeout = setTimeout(() => {
        setShowCopySuccess(false)
      }, 1000)
    } else {
      onClick()
    }
  }

  useEffect(() => {
    return () => clearTimeout(timeout)
  }, [])

  return (
    <span onClick={handleClick} className={styles.item}>
      <div className={styles.textContainer}>
        <i className={`icon icon-${icon}  ${styles.icon} ${styles[icon]}`} />
        <p className={styles.label}>{label}</p>
      </div>
      {showCopySuccess && (
        <span className={styles.success}>
          {label} {t("upload.mobile_share.copied")}
        </span>
      )}
    </span>
  )
}

const MobileShare = ({ onShare, link, embedCode }) => {
  return (
    <div className={styles.container}>
      <MobileShareItem icon="twitter" label="Twitter" onClick={() => onShare("twitter")} />
      <MobileShareItem icon="facebook" label="Facebook" onClick={() => onShare("facebook")} />
      <MobileShareItem icon="linkedin" label="LinkedIn" onClick={() => onShare("linkedin")} />
      <MobileShareItem icon="link" label={t("upload.mobile_share.link")} copyableText={link} />
      <MobileShareItem icon="clock" label={t("upload.published.embed")} copyableText={embedCode} />
    </div>
  )
}

export default MobileShare
